<div class="modal-overlay" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <div class="modal-title-section">
        <i class="fas fa-calendar-check modal-title-icon"></i>
        <h2 class="modal-title">{{ t('bookAppointment') }}</h2>
      </div>
      <button class="close-btn" (click)="onClose()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form class="appointment-form" (ngSubmit)="onSubmit()" #appointmentForm="ngForm">
      <div class="form-group">
        <label for="name" class="form-label">
          <i class="fas fa-user form-label-icon"></i>
          {{ t('appointmentName') }} *
        </label>
        <input 
          type="text" 
          id="name" 
          name="name" 
          class="form-input" 
          [(ngModel)]="appointmentData.name"
          required
          [disabled]="isSubmitting"
          placeholder="{{ t('appointmentNamePlaceholder') }}"
          #nameInput="ngModel"
          (blur)="validateName()"
          (input)="formatName($event); validateName()"
          pattern="[a-zA-Z\s\u0900-\u097F\u0A00-\u0A7F\u0B00-\u0B7F]*"
        >
        <div class="error-message" *ngIf="getErrorMessage('name')">
          {{ getErrorMessage('name') }}
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="age" class="form-label">
            <i class="fas fa-birthday-cake form-label-icon"></i>
            {{ t('appointmentAge') }} *
          </label>
              <input 
                type="number" 
                id="age" 
                name="age" 
                class="form-input" 
                [(ngModel)]="appointmentData.age"
                required
                min="10"
                max="100"
                [disabled]="isSubmitting"
                placeholder="{{ t('appointmentAgePlaceholder') }}"
                #ageInput="ngModel"
                (blur)="validateAge()"
                (input)="validateAge()"
              >
          <div class="error-message" *ngIf="getErrorMessage('age')">
            {{ getErrorMessage('age') }}
          </div>
        </div>

        <div class="form-group">
          <label for="gender" class="form-label">
            <i class="fas fa-venus-mars form-label-icon"></i>
            {{ t('appointmentGender') }} *
          </label>
          <select 
            id="gender" 
            name="gender" 
            class="form-select" 
            [(ngModel)]="appointmentData.gender"
            required
            [disabled]="isSubmitting"
            #genderInput="ngModel"
            (blur)="validateGender()"
            (change)="validateGender()"
          >
            <option value="">{{ t('appointmentSelectGender') }}</option>
            <option value="male">{{ t('appointmentMale') }}</option>
            <option value="female">{{ t('appointmentFemale') }}</option>
            <option value="other">{{ t('appointmentOther') }}</option>
          </select>
          <div class="error-message" *ngIf="getErrorMessage('gender')">
            {{ getErrorMessage('gender') }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="whatsapp" class="form-label">
          <i class="fab fa-whatsapp form-label-icon"></i>
          {{ t('appointmentWhatsApp') }} *
        </label>
        <input 
          type="tel" 
          id="whatsapp" 
          name="whatsapp" 
          class="form-input" 
          [(ngModel)]="appointmentData.whatsappNumber"
          required
          [disabled]="isSubmitting"
          placeholder="{{ t('appointmentWhatsAppPlaceholder') }}"
          #whatsappInput="ngModel"
          (blur)="validateWhatsApp()"
          (input)="formatWhatsAppNumber($event); validateWhatsApp()"
        >
        <div class="error-message" *ngIf="getErrorMessage('whatsapp')">
          {{ getErrorMessage('whatsapp') }}
        </div>
      </div>

      <div class="form-group">
        <label for="address" class="form-label">
          <i class="fas fa-map-marker-alt form-label-icon"></i>
          {{ t('appointmentAddress') }} *
        </label>
        <textarea 
          id="address" 
          name="address" 
          class="form-textarea" 
          [(ngModel)]="appointmentData.address"
          required
          rows="3"
          [disabled]="isSubmitting"
          placeholder="{{ t('appointmentAddressPlaceholder') }}"
          #addressInput="ngModel"
          (blur)="validateAddress()"
          (input)="validateAddress()"
        ></textarea>
        <div class="error-message" *ngIf="getErrorMessage('address')">
          {{ getErrorMessage('address') }}
        </div>
      </div>

      <div class="form-actions">
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="onClose()"
          [disabled]="isSubmitting"
        >
          <i class="fas fa-times"></i>
          &nbsp;{{ t('appointmentCancel') }}
        </button>
        <button 
          type="submit" 
          class="btn btn-primary" 
          [disabled]="isSubmitting || !isFormValid()"
        >
          <i class="fas fa-paper-plane" *ngIf="!isSubmitting"></i>
          <i class="fas fa-spinner fa-spin" *ngIf="isSubmitting"></i>
          <span *ngIf="!isSubmitting">&nbsp;{{ t('appointmentSubmit') }}</span>
          <span *ngIf="isSubmitting">&nbsp;{{ t('appointmentSubmitting') }}</span>
        </button>
      </div>
    </form>
  </div>
</div>
